"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VlIPDCClient = void 0;
const ipdc_product_collections_1 = require("./ipdc-product-collections");
const ipdc_products_1 = require("./ipdc-products");
const ipdc_themes_1 = require("./ipdc-themes");
class VlIPDCClient {
    constructor(apiOptions) {
        this.ipdcProductsClient = new ipdc_products_1.MbpIpdcProductsConfigClient(apiOptions);
        this.ipdcThemesClient = new ipdc_themes_1.MbpIpdcThemesConfigClient(apiOptions);
        this.ipdcProductCollectionsClient =
            new ipdc_product_collections_1.MbpIpdcProductCollectionsConfigClient(apiOptions);
    }
}
exports.VlIPDCClient = VlIPDCClient;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXBkYy1jbGllbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaXBkYy1jbGllbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEseUVBQW1GO0FBQ25GLG1EQUE4RDtBQUM5RCwrQ0FBMEQ7QUFFMUQsTUFBYSxZQUFZO0lBTXZCLFlBQVksVUFBdUI7UUFDakMsSUFBSSxDQUFDLGtCQUFrQixHQUFHLElBQUksMkNBQTJCLENBQUMsVUFBVSxDQUFDLENBQUM7UUFDdEUsSUFBSSxDQUFDLGdCQUFnQixHQUFHLElBQUksdUNBQXlCLENBQUMsVUFBVSxDQUFDLENBQUM7UUFDbEUsSUFBSSxDQUFDLDRCQUE0QjtZQUMvQixJQUFJLGdFQUFxQyxDQUFDLFVBQVUsQ0FBQyxDQUFDO0lBQzFELENBQUM7Q0FDRjtBQVpELG9DQVlDIn0=